import React from 'react';
import Measure from 'react-measure';

function wrapperStyle({ styles }) {
  return styles.toEdgeStyle;
}

export default ({ styles, onChange }) => (
  <Measure
    bounds
    onResize={contentRect => {
      onChange(contentRect.bounds);
    }}
  >
    {({ measureRef }) => (
      <div style={wrapperStyle({ styles })} ref={measureRef} />
    )}
  </Measure>
);



// WEBPACK FOOTER //
// ./src/components/Measure/index.js